import { useDataGeneration, STATUS_GEN, STATUS_LOADING, STATUS_SAVING, STATUS_QUEUED } from "../api/generate/store"
import NewPage from "./Menus/NewPage"
import DataViewPage from "./Menus/DataViewPage"
import { useAuth } from "../api/auth/store"
import Topbar from "../components/Topbar"
import useUxStore from "../api/ux/store"

const GeneratePage = ({}) => {
    const { status, init, generated, genFromCutoff } = useDataGeneration( state => state)
    const { isLogin } = useAuth(state => state)
    const { addToast } = useUxStore(state => state)
    
    const onGenerated = (date:string) => {
        genFromCutoff(date)
            .catch(err => {
                if (err.response?.status !== 401) {
                    addToast("Generation Failed", err.message || "Failed to generate data", null, "danger");
                }
            });
    }
    
    // Removed toast notifications since we now show status in NewPage
    
    if (!isLogin) {
        return <></>
    }
    
    if (status === "") init()

    const loading = status === STATUS_LOADING || status === STATUS_GEN || status === STATUS_SAVING || status === STATUS_QUEUED
    //const showNewPage = status === STATUS_IDLE || loading || status === STATUS_CANCELLED || status === STATUS_TIMEOUT || status === STATUS_ERROR

    //console.log(status, showNewPage, generated)
    if (!generated)
        return <>
            <Topbar />
            <NewPage onGenerate={onGenerated} loading={loading}/>
        </>


    return <>
        <Topbar />
        <DataViewPage generated={generated} status={status}/>
    </>
    
}

export default GeneratePage